import { render, staticRenderFns } from "./placeList.vue?vue&type=template&id=1b8ed96d&scoped=true&"
import script from "./placeList.vue?vue&type=script&lang=js&"
export * from "./placeList.vue?vue&type=script&lang=js&"
import style0 from "./placeList.vue?vue&type=style&index=0&id=1b8ed96d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8ed96d",
  null
  
)

export default component.exports